/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ImportFarseerFileRequestFromJSON(json) {
    return ImportFarseerFileRequestFromJSONTyped(json, false);
}
export function ImportFarseerFileRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        title: json['title'],
        farseerFileId: json['farseerFileId'],
        replacePreviousJobs: !exists(json, 'replacePreviousJobs') ? undefined : json['replacePreviousJobs'],
    };
}
export function ImportFarseerFileRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        title: value.title,
        farseerFileId: value.farseerFileId,
        replacePreviousJobs: value.replacePreviousJobs,
    };
}
